module.exports = __webpack_public_path__ + "media/images/default/default_user_icon_type_4-891a856a0ae96f2cd3fde8c54a232ea8.png";